import React, { useState } from "react";
import {Dialog} from "primereact/dialog";
import FieldTextBox from "../shared/controls/fieldTextBox";
import useApiSeguridad from "../api/seguridad";
import MapaCliente from "./MapaCliente";

const LoginParaMapa = () => {
  const [usuario, setUsuario] = useState("");
  const [password, setPassword] = useState("");
  const [autenticado, setAutenticado] = useState(false);
  const [tokenGenerado, setTokenGenerado] = useState("");
  const seguridad = useApiSeguridad();
  
  const handleLogin = async () => {
    try {
      const res = await seguridad.validarLoginCliente({ usuario, password });
      if (!res) throw new Error("Credenciales inválidas");

      localStorage.setItem("clienteLogueado", "true");
      localStorage.setItem("clienteId", res.clienteId);
      localStorage.setItem("clienteUsuario", res.usuario);
      localStorage.setItem("tokenCliente", res.token);
      localStorage.setItem(`viajes-${res.token}`, JSON.stringify(res.viajes));

      setTokenGenerado(res.token);
      setAutenticado(true);
    } catch (err) {

    }
  };

  if (autenticado) {
    console.log(tokenGenerado)
    return <MapaCliente tokenGenerado={tokenGenerado} />;
  }


  return (
        <Dialog header="Iniciar sesión " visible={true} style={{width: '500px'}}>
            <div className={"form-login"}>
                <FieldTextBox label="Usuario"
                              colMd={12}
                              name="usuario"
                              value={usuario}
                              onChange={setUsuario}
                />
                <FieldTextBox label="Contraseña"
                              colMd={12}
                              name="password"
                              value={password}
                              type={"password"}
                              onChange={setPassword} 
                />
                <div className="form-group col-12">
                    <button type="button" className="btn btn-primary form-control"
                    onClick={handleLogin}>Entrar</button>
                   
                </div>
            </div>
           
            <div>

            </div>
        </Dialog>
  );
};

export default LoginParaMapa;
